<template>
    <div :class="['miniliink', { inApp: $root.$data.isApp || this.$root.miniprogram }]">
        <div class="miniliink-box">
            <img class="pxind" src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/choose_skip.png" alt="" />
            <button @click="goSkip">点击立即定制</button>
        </div>
    </div>
</template>

<script>
import { miniSchemeUrl } from '@/utils/common';
import { reqTypeList } from '@/api/home';

export default {
    data() {
        return {
            code: '',
            apiId: 'wx250c5086c39b7833',
            path: '/pages/chooseSchool/chooseSchool',
            gioParams: null,
        };
    },
    async created() {
        const { code } = this.$route.params;
        this.code = code;
        const res = await reqTypeList('CHOOSE_MINI_CONFIG');
        if (res.code !== 0 || !res.data) return;
        try {
            const config = {};
            res.data.forEach((item) => {
                config[item.code] = JSON.parse(item.value);
            });
            const entryConfig = config[this.code] || {};
            const params = {
                pageName_var: entryConfig.pageName_var || '',
            };
            this.gioParams = params;
        } catch (error) {
            console.log(error);
        }
    },
    methods: {
        async goSkip() {
            gio('track', 'JumpToMiniProgram', this.gioParams);
            const schemeLink = await miniSchemeUrl(this.apiId, this.path, `entryConfig=${this.code}`,)
            if (schemeLink) {
                window.location.href = schemeLink;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.inApp {
    padding-top: 20px !important;
}

.miniliink {
    width: 100%;
    height: 100vh;
    // padding-top: 101px;
    // padding-bottom: 210px;
    background: #f9f9f9;
    user-select: none;

    .miniliink-box {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }

    button {
        display: block;
        width: 569px;
        height: 80px;
        color: #fff;
        font-weight: 500;
        font-size: 29px;
        line-height: 80px;
        border-radius: 45px;
        margin: 72px auto 0;

        background: #FF7F41;
        border-radius: 45rpx;
    }

    .pxind {
        display: block;
        margin: 0 auto;
        width: 750px;
        height: 1152px;
    }
}
</style>
